const isPhone = function(phone) {
  return /^1(3\d|4\d|5\d|6\d|7\d|8\d|9\d)\d{8}$/g.test(phone)
}

const isEmpty = function(obj) {
  if (typeof obj === 'undefined' || obj == null || obj == '') {
    return true
  } else {
    return false
  }
}

// 生成随机id
const getRandomID = function(length) {
  if (length > 0) {
    var data = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I',
      'J', 'K',
      'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e',
      'f', 'g', 'h',
      'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
    ]
    var nums = ''
    for (var i = 0; i < length; i++) {
      var r = parseInt(Math.random() * 61)
      nums += data[r]
    }
    return nums
  } else {
    return ''
  }
}

const getUUID = function() {
  return getRandomID(32)
}

const getEquipmentID = function() {
  var equipment = 'EQUIPMENT_ID'
  var uuid = localStorage.getItem(equipment)

  if (isEmpty(uuid)) {
    uuid = getRandomID(32)
    localStorage.setItem(equipment, uuid)
  }

  return uuid
}

const getCurrentDateTime = function() {
  const date = new Date()
  // 2020
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  // 09
  month = month > 9 ? month : '0' + month
  let day = date.getDate()
  // 07
  day = day > 9 ? day : '0' + day
  // `${}`返回拼接的字符串

  var hour = date.getHours() // 得到小时
  if (hour <= 9) hour = '0' + hour

  var minu = date.getMinutes() // 得到分钟
  if (minu <= 9) minu = '0' + minu

  var second = date.getSeconds() // 得到分钟
  if (second <= 9) second = '0' + second

  return year + '-' + month + '-' + day + ' ' + hour + ':' + minu + ':' + second
}

const getRandomNum = function(length) {
  var tmp = ''
  if (length > 0) {
    // var data = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
    for (var i = 0; i < length; i++) {
      var r = Math.floor(Math.random() * 10)
      tmp = tmp + r
    }
    return tmp
  } else {
    return ''
  }
}



//iCase: 0全到半，1半到全，其他不转化
function changeCase(sStr, iCase) {
	if (
		typeof sStr != "string" ||
		sStr.length <= 0 ||
		!(iCase === 0 || iCase == 1)
	) {
		return sStr;
	}
	var i,
		oRs = [],
		iCode;
	if (iCase) {
		/*半->全*/
		for (i = 0; i < sStr.length; i += 1) {
			iCode = sStr.charCodeAt(i);
			if (iCode == 32) {
				iCode = 12288;
			} else if (iCode < 127) {
				iCode += 65248;
			}
			oRs.push(String.fromCharCode(iCode));
		}
	} else {
		/*全->半*/
		for (i = 0; i < sStr.length; i += 1) {
			iCode = sStr.charCodeAt(i);
			if (iCode == 12288) {
				iCode = 32;
			} else if (iCode > 65280 && iCode < 65375) {
				iCode -= 65248;
			}
			oRs.push(String.fromCharCode(iCode));
		}
	}
	return oRs.join("");
}


export default {
  isEmpty,
  isPhone,
  getEquipmentID,
  getCurrentDateTime,
  getRandomNum,
  changeCase
}



// WEBPACK FOOTER //
// ./src/utils/utils.js